// types
import { NavItemType } from 'types';
import { FormattedMessage } from 'react-intl';
import Renewal from 'assets/icons/Renewal';
import Equipment from 'assets/icons/Equipment';
import Software from 'assets/icons/Software';
import Account from 'assets/icons/Account';
import Rebate from 'assets/icons/Rebate';
import {
    AccountBalanceWalletOutlined,
    AdminPanelSettingsOutlined,
    CalendarMonthOutlined,
    FileDownloadOutlined,
    PhonelinkOutlined
} from '@mui/icons-material';
// import Renewal from 'assets/images/layout/calendar-outline.svg';
// import Equipment from 'assets/images/layout/phone-laptop.svg';
// import Software from 'assets/images/layout/download-outline.svg';
// import Account from 'assets/images/layout/user-shield.svg';
// import Rebate from 'assets/images/layout/rebate.svg'
// ==============================|| MENU ITEMS ||============================== //

const sider: NavItemType = {
    id: 'sider',
    type: 'group',
    children: [
        {
            id: 'renewal',
            title: <FormattedMessage id="renewal.renewal" />,
            icon: CalendarMonthOutlined,
            breadcrumbs: false,
            type: 'item',
            url: '/renewal'
        },
        {
            id: 'equipment',
            title: <FormattedMessage id="equipment.equipment" />,
            icon: PhonelinkOutlined,
            breadcrumbs: false,
            type: 'item',
            url: '/equipment'
        },
        {
            id: 'software',
            title: <FormattedMessage id="software.software" />,
            icon: FileDownloadOutlined,
            breadcrumbs: false,
            type: 'item',
            url: '/software'
        },
        {
            id: 'account',
            title: <FormattedMessage id="account.account" />,
            icon: AdminPanelSettingsOutlined,
            breadcrumbs: false,
            type: 'item',
            url: '/account'
        },
        {
            id: 'rebate',
            title: <FormattedMessage id="rebate" />,
            icon: AccountBalanceWalletOutlined,
            breadcrumbs: false,
            type: 'item',
            url: '/rebate'
        }
    ]
};

const menuItems: { items: NavItemType[] } = {
    items: [sider]
};

export default menuItems;
